/**
 * Mateando Argentina — Upsell de regalo antes del checkout
 * ---------------------------------------------------------
 * Muestra un popup ANTES de ir al pago (tanto con el botón normal
 * "Verificar" como con los botones de pago dinámico: Shop Pay, el botón
 * "Pagar Con Transferencia" de la app de descuentos, etc.) ofreciendo
 * agregar "Caja de regalo" y/o "Bolsa de regalo", pero solo los que
 * todavía NO están en el carrito.
 *
 * v2: todos los botones de pago (no solo los "dinámicos") se interceptan
 * con una capa transparente encima, en vez de escuchar el click sobre el
 * botón mismo. Esto es necesario porque algunos botones ya tienen su
 * propio manejador de click puesto por el tema o por otra app, y si ese
 * manejador se registró antes que el nuestro, se ejecuta primero y puede
 * navegar directo al checkout salteando el popup (o generar demoras raras).
 * Con la capa transparente, el click nunca llega al botón real: siempre
 * lo recibimos nosotros primero, sin importar qué otros scripts corran
 * sobre ese botón.
 *
 * v2 también cachea el carrito en memoria y lo mantiene actualizado, así
 * el popup se abre al instante (sin esperar un fetch) en vez de tardar
 * un round-trip de red cada vez que se hace click en pagar.
 *
 * INSTALACIÓN
 * 1. Admin de Shopify > Tienda online > Temas > ⋯ > Editar código
 * 2. Carpeta "Assets" > "Agregar un activo nuevo" > subir este archivo
 *    (o crear un archivo nuevo llamado gift-upsell.js y pegar este contenido)
 * 3. Abrir layout/theme.liquid, buscar </body> y pegar justo antes:
 *      <script src="{{ 'gift-upsell.js' | asset_url }}" defer></script>
 * 4. Completar los 2 "variantId" de CONFIG más abajo.
 * 5. Guardar y probar (idealmente primero en una copia del tema).
 */

(function () {
  "use strict";

  // ============================================================
  // 1) CONFIGURACIÓN — completar antes de publicar
  // ============================================================
  const CONFIG = {
    giftProducts: [
      {
        productId: 7584614940743, // Caja de regalo (gid://shopify/Product/7584614940743)
        handle: "caja-de-regalo",
        variantId: 42898866569287, // confirmado vía /products/caja-de-regalo.js
        title: "Caja de regalo",
        // Imagen y precio fijos acá abajo (en centavos, /100 al mostrarlos)
        // para que el popup los muestre al instante, sin pedir nada por red.
        // Si cambiás el precio o la foto del producto, actualizá estos dos
        // valores también (podés volver a leerlos de /products/caja-de-regalo.js).
        image: "https://cdn.shopify.com/s/files/1/0667/1443/5655/files/D_NQ_NP_2X_646486-MLA98443849134_112025-F_1_2.jpg?v=1782781548",
        price: 999000,
      },
      {
        productId: 7584614907975, // Bolsa de regalo (gid://shopify/Product/7584614907975)
        handle: "bolsa-de-regalo",
        variantId: 42898866536519, // confirmado vía /products/bolsa-de-regalo.js
        title: "Bolsa de regalo",
        image: "https://cdn.shopify.com/s/files/1/0667/1443/5655/files/IMG_8946_jpg.jpg?v=1787829168",
        price: 390000,
      },
    ],
    // TODOS los botones de pago del carrito que hay que interceptar: el
    // botón normal de checkout, el botón de pago dinámico nativo de
    // Shopify (Shop Pay, etc.) y el botón "Pagar con transferencia" de la
    // app de descuentos. Si en el futuro tu tema agrega otro botón de pago
    // y el popup no se dispara con él, agregá su selector acá.
    checkoutButtonSelectors: [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href="/checkout"]',
      'a[href^="/checkout?"]',
      ".shopify-payment-button",
      "scala-cart-button",
    ],
    texts: {
      title: "¡Antes de pagar! 🎁",
      subtitle: "¿Querés agregar algo para hacerlo un regalo?",
      add: "Agregar",
      added: "✓ Agregado",
      continue: "Continuar al pago",
      cancel: "Volver al carrito",
    },
  };

  // ============================================================
  // 2) LÓGICA — no hace falta tocar nada de acá para abajo
  // ============================================================
  let modalEl = null;
  let bypassIntercept = false; // true mientras redirigimos nosotros mismos al checkout
  let cartWasModified = false; // true si se agregó un regalo desde que se abrió el modal

  // --- Cache del carrito en memoria, para que el popup abra al instante ---
  let lastCart = null;
  let cartFetchInflight = null;

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  }

  function refreshCartCache() {
    // Si ya hay un pedido en curso, lo reusamos en vez de disparar otro en
    // paralelo (evita pedidos duplicados pisándose que solo suman demora).
    if (cartFetchInflight) return cartFetchInflight;
    lastCartFetchAt = Date.now();
    cartFetchInflight = getCart()
      .then((cart) => {
        lastCart = cart;
        cartFetchInflight = null;
        return cart;
      })
      .catch((err) => {
        cartFetchInflight = null;
        throw err;
      });
    return cartFetchInflight;
  }

  function cartHasProduct(cart, productId) {
    return cart.items.some((item) => item.product_id === productId);
  }

  function getPendingGifts(cart) {
    return CONFIG.giftProducts.filter((g) => !cartHasProduct(cart, g.productId));
  }

  function goToCheckout() {
    bypassIntercept = true;
    window.location.href = "/checkout";
  }

  function notifyCartChanged() {
    // Best-effort: muchos temas de Shopify escuchan alguno de estos eventos
    // para refrescar el contador del carrito en el header. No hace nada si
    // el tema no los escucha, así que es inofensivo dispararlos igual.
    ["cart:refresh", "cart:updated", "cart:change", "cart:build"].forEach((name) => {
      try {
        document.dispatchEvent(new CustomEvent(name, { detail: { cart: lastCart } }));
      } catch (e) {
        /* noop */
      }
    });
  }

  function addGiftToCart(gift, onDone) {
    if (!gift.variantId || String(gift.variantId).indexOf("REEMPLAZAR") === 0) {
      alert(
        "Falta configurar el Variant ID de \"" + gift.title + "\" en gift-upsell.js (CONFIG.giftProducts)."
      );
      return;
    }
  const cartDrawerEl = document.querySelector("cart-drawer");
  const cartDrawerSectionId = cartDrawerEl && cartDrawerEl.dataset && cartDrawerEl.dataset.sectionId;
  const addBody = { items: [{ id: gift.variantId, quantity: 1 }] };
  if (cartDrawerSectionId) addBody.sections = [cartDrawerSectionId];
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(addBody),
  })
      .then((r) => {
        if (!r.ok) throw new Error("No se pudo agregar " + gift.title);
        return r.json();
      })
      .then((addResponse) => {
          cartWasModified = true;
        const cartDrawerSectionHtml = cartDrawerSectionId && addResponse && addResponse.sections && addResponse.sections[cartDrawerSectionId];
        refreshCartCache().then(function (freshCart) {
          if (cartDrawerSectionHtml && window.FoxTheme && window.FoxTheme.pubsub) {
            var cartForPubsub = Object.assign({}, freshCart, { sections: addResponse.sections });
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartForPubsub });
          }
          notifyCartChanged();
          if (cartDrawerEl && typeof cartDrawerEl.show === "function") cartDrawerEl.show();
        }).catch(notifyCartChanged);
        onDone(null);
        })
      .catch((err) => onDone(err));
}

  function fetchProductPreview(handle) {
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }

  // Saca el modal del DOM sin más. Se usa tanto para el cierre real como
  // para la limpieza interna cuando se abre un modal nuevo encima de otro
  // (por ejemplo: probaste "Pagar Con Transferencia", volviste, y ahora
  // clickeás "Verificar" — ahí hay que sacar el modal viejo, pero NO
  // corresponde recargar la página todavía, porque no es un cierre real).
  function removeModalDom() {
    if (modalEl) {
      modalEl.remove();
      modalEl = null;
      document.removeEventListener("keydown", onKeydown);
    }
  }

  // Cierre real, iniciado por el usuario (X, click afuera, "Volver al
  // carrito", Esc). Acá sí corresponde chequear si hay que recargar /cart.
  function dismissModal() {
    removeModalDom();

    // Si se agregó algún regalo mientras el popup estaba abierto, la
    // lista de productos y el total que se ven "atrás" (en la página
    // /cart) quedaron desactualizados, porque el agregado se hizo por
    // detrás con fetch y no a través del sistema propio del tema. Este
    // tema es muy custom (ni siquiera usa un <form> normal para el botón
    // de pago), así que en vez de intentar adivinar y parchear su HTML a
    // mano —lo que podría romper algo—, la forma confiable de dejar todo
    // visualmente al día es recargar la página del carrito.
    if (cartWasModified && window.location.pathname === "/cart") {
      cartWasModified = false;
      try {
          sessionStorage.setItem("mateando:reopen-cart-drawer", "1");
        } catch (e) {
          /* noop */
        }
        window.location.reload();
      }
    }
  
  function onKeydown(e) {
    if (e.key === "Escape") dismissModal();
  }

  function renderModalShell(loading) {
    removeModalDom(); // limpieza interna: nunca dispara la recarga

    const overlay = document.createElement("div");
    overlay.id = "gift-upsell-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML =
      '<div class="gift-upsell-backdrop"></div>' +
      '<div class="gift-upsell-dialog">' +
      '  <button type="button" class="gift-upsell-close" aria-label="Cerrar">&times;</button>' +
      '  <h2 class="gift-upsell-title"></h2>' +
      '  <p class="gift-upsell-subtitle"></p>' +
      '  <div class="gift-upsell-items"></div>' +
      '  <div class="gift-upsell-actions">' +
      '    <button type="button" class="gift-upsell-btn gift-upsell-btn--secondary" data-action="cancel"></button>' +
      '    <button type="button" class="gift-upsell-btn gift-upsell-btn--primary" data-action="continue"></button>' +
      "  </div>" +
      "</div>";

    injectStyles();

    overlay.querySelector(".gift-upsell-title").textContent = CONFIG.texts.title;
    overlay.querySelector(".gift-upsell-subtitle").textContent = CONFIG.texts.subtitle;
    overlay.querySelector('[data-action="cancel"]').textContent = CONFIG.texts.cancel;
    overlay.querySelector('[data-action="continue"]').textContent = CONFIG.texts.continue;

    if (loading) {
      overlay.querySelector(".gift-upsell-items").innerHTML =
        '<div class="gift-upsell-loading">Cargando…</div>';
    }

    overlay.querySelector(".gift-upsell-close").addEventListener("click", dismissModal);
    overlay.querySelector(".gift-upsell-backdrop").addEventListener("click", dismissModal);
    overlay.querySelector('[data-action="cancel"]').addEventListener("click", dismissModal);
    overlay.querySelector('[data-action="continue"]').addEventListener("click", () => {
      removeModalDom(); // vamos directo a /checkout, no hace falta recargar /cart antes
      goToCheckout();
    });

    document.body.appendChild(overlay);
    document.addEventListener("keydown", onKeydown);
    modalEl = overlay;
    return overlay;
  }

  function fillModalItems(overlay, pendingGifts) {
    if (!modalEl || modalEl !== overlay) return; // el modal se cerró/reemplazó mientras tanto
    const itemsWrap = overlay.querySelector(".gift-upsell-items");
    itemsWrap.innerHTML = "";

    pendingGifts.forEach((gift) => {
      const card = document.createElement("div");
      card.className = "gift-upsell-item";
      // La imagen y el precio salen directo de CONFIG (hardcodeados), así
      // se muestran de una, sin esperar ningún pedido de red.
      const mediaHtml = gift.image
        ? '<img src="' + gift.image + '" alt="' + gift.title + '">'
        : "";
      const priceHtml = gift.price != null ? "$" + (gift.price / 100).toFixed(0) : "";
      card.innerHTML =
        '<div class="gift-upsell-item__media">' + mediaHtml + "</div>" +
        '<div class="gift-upsell-item__body">' +
        '  <p class="gift-upsell-item__title">' + gift.title + "</p>" +
        '  <p class="gift-upsell-item__price">' + priceHtml + "</p>" +
        "</div>" +
        '<button type="button" class="gift-upsell-btn gift-upsell-btn--add">' + CONFIG.texts.add + "</button>";
      itemsWrap.appendChild(card);

      // Si a algún producto le falta la imagen o el precio fijo en CONFIG
      // (por ejemplo, agregaste un regalo nuevo y todavía no lo cargaste),
      // lo buscamos por red como respaldo, en segundo plano.
      if (!gift.image || gift.price == null) {
        fetchProductPreview(gift.handle).then((product) => {
          if (!product) return;
          const media = card.querySelector(".gift-upsell-item__media");
          if (!gift.image && product.featured_image && !media.querySelector("img")) {
            const img = document.createElement("img");
            img.src = product.featured_image;
            img.alt = gift.title;
            media.appendChild(img);
          }
          const price = card.querySelector(".gift-upsell-item__price");
          if (gift.price == null && product.price != null) {
            price.textContent = "$" + (product.price / 100).toFixed(0);
          }
        });
      }

      card.querySelector(".gift-upsell-btn--add").addEventListener("click", function () {
        const btn = this;
        if (btn.disabled) return;
        // Actualización optimista: lo marcamos como agregado al toque,
        // sin esperar la respuesta de red, para que se sienta instantáneo.
        // Si el pedido falla, lo revertimos y avisamos.
        btn.disabled = true;
        btn.textContent = CONFIG.texts.added;
        card.classList.add("gift-upsell-item--added");
        addGiftToCart(gift, (err) => {
          if (err) {
            btn.disabled = false;
            btn.textContent = CONFIG.texts.add;
            card.classList.remove("gift-upsell-item--added");
            alert("Hubo un problema agregando " + gift.title + ". Probá de nuevo.");
          }
        });
      });
    });
  }

  function openModal(pendingGifts) {
    const overlay = renderModalShell(false);
    fillModalItems(overlay, pendingGifts);
  }

  function handleCheckoutAttempt(e) {
    if (bypassIntercept) return; // dejamos pasar la redirección que hicimos nosotros
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // Camino rápido: si ya tenemos el carrito en cache, el popup abre al
    // instante en vez de esperar un fetch. Refrescamos el cache en
    // segundo plano por si cambió algo (otra pestaña, etc.).
    if (lastCart) {
      const pending = getPendingGifts(lastCart);
      if (pending.length === 0) {
        goToCheckout();
      } else {
        openModal(pending);
      }
      refreshCartCache();
      return;
    }

    // No hay cache todavía (primer click antes de que termine el fetch
    // inicial): mostramos el modal con un estado de carga en vez de dejar
    // la pantalla sin reaccionar, y lo completamos apenas llega la data.
    const overlay = renderModalShell(true);
    (cartFetchInflight || refreshCartCache())
      .then((cart) => {
        const pending = getPendingGifts(cart);
        if (pending.length === 0) {
          removeModalDom();
          goToCheckout();
          return;
        }
        fillModalItems(overlay, pending);
      })
      .catch(() => {
        // Si falló el pedido al carrito, no dejamos al usuario trabado
        // mirando "Cargando…" para siempre: mostramos un aviso con la
        // opción de reintentar o de seguir directo a pagar.
        if (!modalEl || modalEl !== overlay) return;
        const itemsWrap = overlay.querySelector(".gift-upsell-items");
        itemsWrap.innerHTML =
          '<div class="gift-upsell-loading">No pudimos cargar el carrito. ' +
          '<a href="#" class="gift-upsell-retry">Reintentar</a></div>';
        itemsWrap.querySelector(".gift-upsell-retry").addEventListener("click", (ev) => {
          ev.preventDefault();
          handleCheckoutAttempt(ev);
        });
      });
  }

  // ------------------------------------------------------------
  // Enganche de listeners: ponemos una capa transparente encima de CADA
  // botón de pago que interceta el click antes de que llegue al botón
  // real. Así no importa si el botón ya tiene su propio manejador de
  // click puesto por el tema o por otra app: nunca llega a dispararse,
  // porque el click cae sobre nuestra capa, no sobre el botón.
  //
  // Nota: Apple Pay / Google Pay pueden requerir que el click ocurra
  // directamente sobre su botón nativo por restricciones del navegador;
  // en esos casos la capa puede no dispararlos. Shop Pay, "Verificar" y
  // "Pagar con transferencia" funcionan bien con este método.
  // ------------------------------------------------------------
  function bindCheckoutInterceptors(root) {
    let boundNew = false;
    CONFIG.checkoutButtonSelectors.forEach((sel) => {
      root.querySelectorAll(sel).forEach((container) => {
        if (container.dataset.giftUpsellBound) return;
        container.dataset.giftUpsellBound = "1";
        boundNew = true;

        const wrapper = document.createElement("div");
        wrapper.style.position = "relative";
        wrapper.style.display = "block";
        wrapper.style.width = "100%";
        container.parentNode.insertBefore(wrapper, container);
        wrapper.appendChild(container);

        const overlay = document.createElement("div");
        overlay.className = "gift-upsell-btn-overlay";
        overlay.style.display = "block"; // algunos temas ocultan los <div> vacíos por CSS (div:empty)
        overlay.style.position = "absolute";
        overlay.style.inset = "0";
        overlay.style.zIndex = "10";
        overlay.style.cursor = "pointer";
        overlay.style.background = "transparent";
        wrapper.appendChild(overlay);

        overlay.addEventListener("click", handleCheckoutAttempt, true);
      });
    });
    // Si apareció un botón de pago nuevo (no visto antes), es una señal
    // fuerte de que el carrito/drawer se acaba de re-renderizar con
    // contenido fresco (por ejemplo, se reabrió el cart drawer). Ahí
    // conviene refrescar el cache YA, sin esperar el debounce general,
    // para que el próximo click sobre ese botón use datos al día.
    if (boundNew) refreshCartCache();
  }

  function bindAll() {
    bindCheckoutInterceptors(document);
  }

  function injectStyles() {
    if (document.getElementById("gift-upsell-styles")) return;
    const style = document.createElement("style");
    style.id = "gift-upsell-styles";
    style.textContent =
      "#gift-upsell-overlay{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;}" +
      ".gift-upsell-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.5);}" +
      ".gift-upsell-dialog{position:relative;background:#fff;border-radius:12px;max-width:440px;width:100%;padding:24px;box-shadow:0 10px 40px rgba(0,0,0,.2);max-height:90vh;overflow-y:auto;font-family:inherit;}" +
      ".gift-upsell-close{position:absolute;top:12px;right:12px;background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:#666;}" +
      ".gift-upsell-title{margin:0 0 4px;font-size:20px;font-weight:700;}" +
      ".gift-upsell-subtitle{margin:0 0 16px;color:#555;font-size:14px;}" +
      ".gift-upsell-items{display:flex;flex-direction:column;gap:12px;margin-bottom:20px;min-height:40px;}" +
      ".gift-upsell-loading{color:#888;font-size:14px;padding:8px 0;}" +
      ".gift-upsell-retry{color:#111;text-decoration:underline;}" +
      ".gift-upsell-item{display:flex;align-items:center;gap:12px;border:1px solid #e5e5e5;border-radius:8px;padding:10px;}" +
      ".gift-upsell-item__media{width:56px;height:56px;flex:0 0 56px;background:#f5f5f5;border-radius:6px;overflow:hidden;}" +
      ".gift-upsell-item__media img{width:100%;height:100%;object-fit:cover;display:block;}" +
      ".gift-upsell-item__body{flex:1;min-width:0;}" +
      ".gift-upsell-item__title{margin:0;font-weight:600;font-size:14px;}" +
      ".gift-upsell-item__price{margin:2px 0 0;font-size:13px;color:#666;}" +
      ".gift-upsell-item--added{opacity:.6;}" +
      ".gift-upsell-actions{display:flex;flex-direction:column;gap:8px;}" +
      ".gift-upsell-btn{border-radius:8px;padding:12px 16px;font-size:14px;font-weight:600;cursor:pointer;border:1px solid transparent;}" +
      ".gift-upsell-btn--add{flex:0 0 auto;background:#111;color:#fff;padding:8px 14px;font-size:13px;}" +
      ".gift-upsell-btn--add:disabled{opacity:.6;cursor:default;}" +
      ".gift-upsell-btn--primary{background:#111;color:#fff;}" +
      ".gift-upsell-btn--secondary{background:#fff;color:#111;border-color:#ccc;}";
    document.head.appendChild(style);
  }

  let refreshDebounce = null;
  let lastCartFetchAt = 0;
  const CART_REFRESH_MIN_INTERVAL = 1000;
  function scheduleCartRefresh() {
    if (refreshDebounce) return;
    const wait = Math.max(120, CART_REFRESH_MIN_INTERVAL - (Date.now() - lastCartFetchAt));
    refreshDebounce = setTimeout(() => {
      refreshDebounce = null;
      refreshCartCache();
    }, wait);
  }
function maybeReopenCartDrawer() {
  let shouldOpen = false;
  try {
    shouldOpen = sessionStorage.getItem("mateando:reopen-cart-drawer") === "1";
    if (shouldOpen) sessionStorage.removeItem("mateando:reopen-cart-drawer");
  } catch (e) {
    shouldOpen = false;
  }
  if (!shouldOpen) return;
  const openDrawer = function () {
    const cartDrawerEl = document.querySelector("cart-drawer");
    if (cartDrawerEl && typeof cartDrawerEl.show === "function") cartDrawerEl.show();
  };
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined("cart-drawer").then(openDrawer).catch(openDrawer);
  } else {
    openDrawer();
  }
}
  function init() {
    bindAll();
    maybeReopenCartDrawer();
    refreshCartCache(); // precarga el carrito para que el primer click ya sea instantáneo
    // El carrito (drawer/página) se re-renderiza cada vez que cambia el
    // contenido (AJAX), así que observamos el DOM para: (1) volver a
    // enganchar los listeners cuando aparecen botones nuevos, y (2)
    // refrescar el cache del carrito por si cambió la cantidad de items
    // (por ejemplo, sumaste/restaste cantidad a mano en el carrito).
    const observer = new MutationObserver(() => {
      bindAll();
      scheduleCartRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Si volvés a la pestaña (o el navegador restaura la página desde su
    // caché al navegar "atrás"), el cache podría haber quedado viejo —
    // lo refrescamos apenas la página vuelve a estar visible.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") refreshCartCache();
    });
    window.addEventListener("pageshow", () => refreshCartCache());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();